import { Navigate } from 'react-router';
import { useAuth } from '../lib/auth';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--vivid-purple)] border-t-transparent" />
      </div>
    );
  }

  const isPartner = user?.partner_ids && user.partner_ids.length > 0;

  // Not logged in → go to login page
  if (!user) {
    return <Navigate to="/cont" replace />;
  }

  // Logged in but not staff/partner → go to home
  if (!user.is_staff && !isPartner) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
